import { render, staticRenderFns } from "./WidgetIcons.vue?vue&type=template&id=40526c30"
import script from "./WidgetIcons.vue?vue&type=script&lang=js"
export * from "./WidgetIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports